export function turnItemViews(itemViews) {
  return itemViews.map(itemView => {
    if (itemView.params.isNotTurnable) return itemView

    if (itemView.boundary.width < 0) {
      itemView.boundary.x += itemView.boundary.width
      itemView.boundary.width *= -1
    }

    if (itemView.boundary.height < 0) {
      itemView.boundary.y += itemView.boundary.height
      itemView.boundary.height *= -1
    }

    return itemView
  })
}

export function removeEmptyItemViews(itemViews) {
  const checkIsLine = ({ params: { isLine }, boundary: { width, height } }) => {
    if (!isLine) return false
    if (width === 0 && height === 0) return false

    return true
  }

  const checkIsNotLine = ({ params: { isLine }, boundary: { width, height } }) => {
    if (isLine) return false
    if (width <= 0) return false
    if (height <= 0) return false

    return true
  }

  return itemViews.filter(
    itemView => itemView.params.isUndeletable || checkIsLine(itemView) || checkIsNotLine(itemView),
  )
}

export function fromArrayToObject(arr, key) {
  const obj = {}

  if (!Array.isArray(arr)) return obj

  arr.forEach(item => {
    if (!item[key]) return

    obj[item[key]] = { ...item }
  })

  return obj
}

export function rotatePoint(centerPoint, absolutePoint, angle) {
  if (angle == 0) return absolutePoint

  const rx = absolutePoint.x - centerPoint.x
  const ry = absolutePoint.y - centerPoint.y
  const cos = Math.cos(-angle)
  const sin = Math.sin(-angle)

  return {
    x: centerPoint.x + rx * cos - ry * sin,
    y: centerPoint.y + rx * sin + ry * cos,
  }
}



// WEBPACK FOOTER //
// ./src/drawing/core/utils.js